import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export type BreakdownMode = 'counts' | 'premium'

const COUNT_SERIES = [
  { key: 'generated', color: '#22c55e' },
  { key: 'declined', color: '#ef4444' },
  { key: 'unavailable', color: '#f59e0b' },
  { key: 'error', color: '#b91c1c' },
]
const PREMIUM_SERIES = [{ key: 'premium', color: '#6366f1' }]

const usd = (n: number) => `$${Math.round(n).toLocaleString()}`

export function BreakdownBarChart<T extends object>({
  data,
  xKey,
  mode,
}: {
  data: T[]
  xKey: string
  mode: BreakdownMode
}) {
  const series = mode === 'premium' ? PREMIUM_SERIES : COUNT_SERIES
  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis tickFormatter={mode === 'premium' ? (v: number) => usd(v) : undefined} />
        <Tooltip
          formatter={
            mode === 'premium' ? (v) => (typeof v === 'number' ? usd(v) : String(v ?? '')) : undefined
          }
        />
        <Legend />
        {series.map((s) => (
          <Bar key={s.key} dataKey={s.key} fill={s.color} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}
